/**
 * Created by js on 21.02.2018.
 */

import {main_instance} from './main';

class Navigation{

    constructor()
    {
        this.document_height = 0;
        this.window_height = 0;
        this.anchors = [];
    }
    
    init()
    {
        //set vars
        this.main = main_instance;
        this.$window = this.main.$window;

        this.$navi_main = $('#nav-main');
        this.$btn_up = $('#btn-scroll-to-top');
        this.$burger_menu  = $('#nav-burger-icon');

        this.scrollOffset = 40;
        
        this.setAnchors();
        this.addListeners();
    }
    
    onScroll(e)
    {
        let scrolltop = this.$window.scrollTop();

        scrolltop >= 60 ? this.$navi_main.addClass('sticky') : this.$navi_main.removeClass('sticky');
        scrolltop >= this.window_height ? this.$btn_up.addClass('visible') : this.$btn_up.removeClass('visible');

        //set navi item highlight on passing an anchor
        let l = this.anchors.length;
        for(let i = 0; i< l; i++)
        {
            let array_item = this.anchors[i];


            /**
             * (removed highlighting on scroll - 2018/03/09)
             *
            let next_item_y = i < l-1 ? this.anchors[i+1].y : this.document_height;

            if (scrolltop > (array_item.y-this.scrollOffset-5) && scrolltop < (next_item_y-this.scrollOffset-5))
            {
                this.$navi_main.find('li').removeClass('active');
                array_item.$anchor_li.addClass('active');
            }
            //reset main navi item highlight on #home
            else if(i == 0 && scrolltop < (array_item.y-this.scrollOffset) )
            {
                this.$navi_main.find('li:first-child').removeClass('active');
            }
            */


            //content-fading
            if ( scrolltop + this.window_height*0.75 > array_item.y )
            {
                array_item.$item.addClass('visible');
                if(array_item.$item.attr('id') == 'technologie')
                {
                    this.main.setupSpin();
                }
            }
        }
    }

    resizeComplete()
    {
        this.document_height = $(document).height();
        this.window_height = this.$window.innerHeight();
        this.setAnchors();
        this.onScroll();
    }

    setAnchors()
    {
        this.$navi_main.find('li:not(.mobile-lang-navi-item) a').each((index, elem)=>{
            var $anchor = $(elem);
            var href = $anchor.attr('href').substr(1);
            var $content_item = $('#'+href);
            var current_anchor_y = $content_item.offset().top;
            this.anchors[index] = {y: current_anchor_y, href: href, $item: $content_item, $anchor_li: $anchor.parent('li')};
        });
    }

    addListeners()
    {
        this.$navi_main.find('a').click((e)=>{

            let $this = $(e.currentTarget);
            let href = $this.attr('href');

            this.$navi_main.removeClass('open');

            //if no anchor -> default action
            if(href.charAt(0) !== "#")return true;


            var scrolltop = href.substr(1) == 'home' ? 0 :  $(href).offset().top - this.scrollOffset;

            $('html, body').animate({
                scrollTop : scrolltop
            },'slow');

            return false;
        });

        this.$btn_up.click((e)=>{

            $('html, body').animate({
                scrollTop : 0
            },'slow');

            this.$navi_main.removeClass('open');

            return false;
        });

        this.$burger_menu.click((e)=>{
            this.$navi_main.toggleClass('open');
        });
    }
}

//export only instance ( =  singleton)
export let navigation = new Navigation();


// WEBPACK FOOTER //
// ./src/script/navigation.js